// extracted by mini-css-extract-plugin
export default {"zoomModal":"k2-z"};